const cs = {
  players: "Hráči",
  tournaments: "Turnaje",
  matches: "Zápasy",
  firstName: "Jméno",
  lastName: "Příjmení",
  nickname: "Přezdívka",
  elo: "Elo",
  tournamentName: "Název turnaje",
  tournamentSystem: "Typ turnaje",
  addNewPlayer: "Přidat nového hráče",
  editPlayer: "Upravit hráče",
  optional: "nepovinné",
  startingElo: "Počáteční Elo rating (úroveň hráče)",
  beginner: "Začátečník",
  intermediate: "Mírně pokročilý",
  advanced: "Pokročilý",
  expert: "Expert",
  createPlayer: "Přidat hráče",
  listOfPlayers: "Seznam všech hráčů",
  listOfTournaments: "Seznam všech turnajů",
  addNewTournament: "Vytvořit nový turnaj",
  createTournament: "Vytvořit turnaj",
  tournamentSystem_SWISS: "Švýcarský systém",
  tournamentSystem_GROUPS: "Skupinový systém",
  tournamentSystem_GROUPS_PLAYOFF: "Skupiny + Playoff",
  tournamentSystem_BLAST: "Blast",
  setsNeededToWin: "Počet vítězných setů",
  setsToWin: "Vítězné sety",
  ladderStatistics: "Statistiky žebříčku",
  totalTournaments: "Celkem turnajů",
  totalMatches: "Celkem zápasů",
  records: "Rekordy",
  highestEloEver: "Nejvyšší Elo",
  mostTournamentsWon: "Nejvíce vyhraných turnajů",
  mostTournamentsPlayed: "Nejvíce odehraných turnajů",
  mostMatchesPlayed: "Nejvíce odehraných zápasů",
  wins: "výher",
  setsPlayed: "odehraných setů",
  pointsPlayed: "odehraných bodů",
  ranking: "Žebříček",
  tournamentState: "Stav turnaje",
  tournamentState_NOT_STARTED: "Nastavuje se",
  tournamentState_IN_PROGRESS: "Probíhá",
  tournamentState_FINISHED: "Ukončen",
  tournamentState_CANCELED: "Zrušen",
  search: "Hledat",
  player: "Hráč",
  seeding: "Nasazení",
  saveSeeding: "Uložit nasazení",
  startTournament: "Začít turnaj",
  matchesWon: "Výhrané zápasy",
  matchesLost: "Prohrané zápasy",
  pointsWon: "Vyhrané míčky",
  pointsLost: "Prohrané míčky",
  setsWon: "Vyhrané sety",
  setsLost: "Prohrané sety",
  points: "Výměny",
  sets: "Sety",
  score: "Skóre",
  roundNumber: "{{roundNumber}}. Kolo",
  group: "Skupina",
  groups: "Skupiny",
  groupTab: "Skupina {{groupNumber}}",
  setResult: "Zadat výsledek",
  playerWon: "Vyhrál {{player}}",
  playerDefaultWin: "Kontumační výhra - {{player}}",
  save: "Uložit",
  matchResult: "Výsledek zápasu",
  setNumber: "{{number}}. Set",
  roundInProgress: " (Hraje se)",
  roundDurationRunning: "Kolo běží:",
  roundDurationFinished: "Kolo trvalo:",
  newRoundStartedTitle: "Začalo nové kolo!",
  newRoundStartedBody: "Bylo vyhlášeno {{round}}. kolo.",
  goToNewRound: "Přejít na nové kolo",
  finishRound: "Ukončit Kolo",
  cancelRound: "Zrušit Kolo",
  cancel: "Zrušit",
  rounds: "Kola",
  confirm: "Potvrdit",
  cancelRoundConfirmation: "Opravdu chcete toto kolo zrušit? Tuto akci nelze vrátit zpátky.",
  finishTournament: "Ukončit Turnaj",
  finishTournamentConfirmation: "Opravdu chcete turnaj ukončit? Tuto akci nelze vrátit zpátky.",
  doubleElimination: "Double Elimination",
  finalPlacement: "Výsledky",
  myMatches: "Moje zápasy",
  playerProfile: "Profil hráče",
  statistics: "Statistiky",
  rank: "Pořadí",
  tournamentsPlayed: "Odehrané turnaje",
  averagePercentile: "Ø Percentil",
  placement: "Umístění",
  totalPlayers: "Počet hráčů",
  startingEloShort: "Počáteční rating",
  eloEvolution: "Vývoj Elo ratingu",
  login: "Přihlásit se",
  logout: "Odhlásit se",
  createAccount: "Vytvořit účet",
  loginAsAdministrator: "Přihlásit se jako Administrátor",
  username: "Přihlašovací jméno",
  password: "Heslo",
  confirmPassword: "Potvrdit heslo",
  noTournamentsYet: "Tento hráč ješťě nemá odehraný žádný turnaj.",
  noMatchesYet: "Tento hráč ješťě nemá odehraný žádný zápas.",
  achievements: "Ocenění",
  achievementTitle__GOLD: "Zlatá medaile",
  achievementTitle__SILVER: "Stříbrná medaile",
  achievementTitle__BRONZE: "Bronzová medaile",
  achievementTitle__POTATO: "Bramborová medaile",
  achievementTitle__HAT_TRICK: "Hat-Trick",
  achievementTitle__UNDEFEATED: "Neporazitelný",
  achievementTitle__UNSTOPPABLE: "Nezastavitelný",
  achievementTitle__DISHONORED: "Zneuctění",
  achievementTitle__PLOT_TWIST: "Nečekaný zvrat",
  achievementTitle__PROPHECY: "Proroctví",
  achievementTitle__HARDEST_PATH: "Nejobtížnější cesta",
  achievementTitle__NO_HURRY: "Budu potřebovat větší ručník",
  achievementTitle__TIME_IS_MONEY: "Spěchám domů",
  achievementTitle__GET_YOUR_MONEYS_WORTH: "Dostanu, co jsem si zaplatil",
  achievementTitle__ALL_THINGS_MUST_BE_BALANCED: "Dokonale vyvážený",
  achievementTitle__PEAK_PERFORMANCE: "Špičkový výkon",
  achievementTitle__CONSISTENCY_IS_KEY: "Konzistence je klíčem k úspěchu",
  achievementTitle__BACK_FROM_THE_DEAD: "Povstání z mrtvých",
  achievementDescription__GOLD: "Skonči na prvním místě",
  achievementDescription__SILVER: "Skonči na druhém místě",
  achievementDescription__BRONZE: "Skonči na třetím místě",
  achievementDescription__POTATO: "Skonči na čtvrtém místě",
  achievementDescription__HAT_TRICK: "Vyhrej tři zápasy v řadě (v jednom turnaji)",
  achievementDescription__UNDEFEATED: "Vyhrej všechny zápasy",
  achievementDescription__UNSTOPPABLE: "Vyhrej všechny sety",
  achievementDescription__DISHONORED: "Vyhrej set bez ztráty jediného míčku",
  achievementDescription__PLOT_TWIST: "Dosáhni největšího rozdílu mezi nasazenou a finální pozicí",
  achievementDescription__PROPHECY: "Skonči na stejné pozici, na které jsi byl nasazen",
  achievementDescription__HARDEST_PATH: "Skonči s nejvyšším Buchholz skóre",
  achievementDescription__NO_HURRY: "Skonči s nejvyšším počtem odehraných výměn",
  achievementDescription__TIME_IS_MONEY: "Skonči s nejnižším počtem odehraných výměn",
  achievementDescription__GET_YOUR_MONEYS_WORTH: "Skonči s nejvyšším počtem odehraných setů",
  achievementDescription__ALL_THINGS_MUST_BE_BALANCED: "Skonči s nulovým rozdílem mezi vyhranými a prohranými výměnami",
  achievementDescription__PEAK_PERFORMANCE: "Dosáhni nejvyššího zápasového ratingu v turnaji",
  achievementDescription__CONSISTENCY_IS_KEY: "Dosáhni nejvyššího turnajového ratingu",
  achievementDescription__BACK_FROM_THE_DEAD: "Vyhrej zápas, ve kterém jsi prohrával 0:2",
  achievementTitle__FLASH: "Flash",
  achievementDescription__FLASH: "Nahlásil jsi výsledek rychleji než kdokoliv jiný",
  achievementTitle__SLOWPOKE: "Slowpoke",
  achievementDescription__SLOWPOKE: "Na výsledek tvého zápasu se čekalo ze všech nejdéle",
  date: "Datum",
  tournamentDate: "Datum turnaje",
  sortByElo: "Seřadit podle Elo",
  nationality: "Národnost",
  awardedAchievements: "Udělená ocenění",
  welcomeHeaderRaw: "Vítej na ping pongovém hřišti!",
  welcomeHeaderRawMobile: "Vítej na ping\npongovém hřišti!",
  welcomeHeader: "Vítej na <span class='loss'>P</span>ing<span class='loss'>P</span>ongovém hřišti!",
  welcomeText1: "<b class='win'>Hravé Turnaje</b> Ti umožní sledovat své statistiky, sbírat ocenění za výkony a porovnávat svůj rating s přáteli. <a href=\"https://stolnitenisbrno.isportsystem.cz/\">Přihlaš se na turnaj</a> a získej svoje místo v síni slávy!",
  welcomeText2: "Tuto stránku vytvořil s láskou k ping pongu a Hravému Baru <b>Seboš</b>. Velké díky patří mému kamarádovi <b>beavis</b>ovi za hostování webové aplikace a nekonečnou dávku motivace při jejím vývoji.",
  welcomeText3: "Tato verze webu je zatím pouze první pracovní verzí.\n" +
    "Je možné, že se v ní ještě objeví chyby nebo nedostatky. Budu moc rád za jakékoli připomínky, nápady či zpětnou vazbu – pomohou mi web dál vylepšovat.",
  myreg: "Myreg<br />je<br />HLUPÁK<br />🤐",
  notFound: "Nevím co hledáš, ale tady to nenajdeš. :(",
  pointAbbreviation: "b",
  opponents: "soupeři",
  editTournament: "Upravit turnaj",
  news: "Novinky",
  buchholzScore: "(Bch) - Buchholz skóre",
  buchholzScoreDescription: "Buchholz skóre je součet bodů všech soupeřů hráče – měří, jak silné měl soupeře.",
  plannedChanges: "Plánované změny",
  unreleasedChanges: "Nevydané změny",
  beginnerLadder: "Začátečníci",
  intermediateLadder: "Mírně pokročilí",
  advancedLadder: "Pokročilí",
  ladders: "Žebříčky",
  officialLadders: "Oficiální žebříčky",
  unofficialLadders: "Neoficiální žebříčky",
  createLadder: "Vytvořit žebříček",
  ladderNameCs: "Název (česky)",
  ladderNameEn: "Název (anglicky)",
  newLadderIntro: "Žebříček ti umožní pořádat turnaje s vlastním ELO a oceněními, oddělenými od ostatních žebříčků. Můžeš nastavit, kdo z ostatních uživatelů bude moct v žebříčku vytvářet a ovládat turnaje.",
  newLadderNoLadderHint: "Pokud chceš jen jednorázově uspořádat turnaj a žebříček tě nezajímá, nemusíš žádný vytvářet — při vytváření turnaje stačí zvolit „Bez žebříčku\".",
  basicInformation: "Základní informace",
  showAdvancedSettings: "Zobrazit rozšířené nastavení",
  hideAdvancedSettings: "Skrýt rozšířené nastavení",
  advancedSettings: "Rozšířené nastavení",
  calculateEloHint: "Po každém zápase se hráčům upraví ELO v tomto žebříčku.",
  discountCloseLossHint: "Prohru v těsných zápasech potrestá menší ztrátou ELO.",
  calculateRatingHint: "Každému hráči se za každý zápas počítá výkonnostní skóre (0–2), z těch se pak spočítá průměr za celý turnaj.",
  awardAchievementsHint: "V turnajích tohoto žebříčku se udělují ocenění (např. Zlato, Stříbro).",
  calculateElo: "Počítat ELO hráčů",
  discountCloseLoss: "Odečítat méně ELO při vyrovnané prohře",
  calculateRating: "Počítat výkonnostní rating",
  awardAchievements: "Udělovat ocenění",
  ladderOwner: "Vlastník",
  ladderOrganizers: "Organizátoři",
  transferOwnership: "Předat vlastnictví",
  addOrganizer: "Přidat organizátora",
  removeOrganizer: "Odebrat organizátora",
  removeOrganizerConfirmation: "Opravdu chceš odebrat organizátora {{username}}?",
  transferOwnershipConfirmation: "Opravdu chceš předat vlastnictví žebříčku uživateli {{username}}? Vrátit to pak může jen nový vlastník nebo admin.",
  ladderSettings: "Nastavení žebříčku",
  unofficialLaddersIntro: "Stisknutím tlačítka „+\" v pravém horním rohu si můžeš vytvořit vlastní žebříček.",
  noUnofficialLadders: "Zatím tu žádný neoficiální žebříček není.",
  addPlayerAdminHint: "Nový hráč se automaticky přidá do centrálního seznamu.",
  close: "Zavřít",
  notAuthorized: "K tomuto nastavení nemáš přístup.",
  noLadder: "Bez žebříčku",
  playerLadders: "Žebříčky hráčů",
  tournamentsColumn: "Turnajů",
  playersColumn: "Hráčů",
  organizer: "Organizátor turnaje",
  ladder: "Žebříček",
  administration: "Super úžasná administrátorská stránka",
  recalculateElo: "Přepočítat elo",
  outOf: "z",
  homepageTournaments: "Turnajů",
  homepagePoints: "Výměn",
  homepageMatches: "Zápasů",
  homepagePlayers: "Hráčů",
  homepageAchievements: "Ocenění",
  numberOfGroups: "Počet skupin",
  groupShort: "S",
  info: "Info",
  information: "Informace",
  averageElo: "Průměrný Elo rating",
  passwordDoesNotMatch: "Hesla se neshodují",
  usernameAlreadyExists: "Účet s tímto jménem již existuje",
  createAccountInfo: "Po vytvoření účtu požádejte pořadetele turnaje o propojení s Vaším herním profilem. Tím získáte možnost samostatného zadávání výsledků zápasů.",
  somethingWentWrong: "Ajaj, něco se pokazilo. Prosím kontaktujte administrátora pro vyřešení tohoto problému.",
  userAccount: "Uživatelský účet",
  noUserAccount: "Hráč zatím nemá uživatelský účet",
  about: "O aplikaci",
  usernameOnlyLettersNumbers: "Uživatelské jméno může obsahovat pouze písmena a čísla",
  scoretable: "Tabulka",
  round: "Kolo",
  wrongPassword: "Špatné heslo, prosím zkuste to znovu",
  achievementsAndStats: "Statistiky a ocenění",
  averagePercentileHeader: "Průměrný percentil",
  averagePercentileDescription: "Počítá se jako aritmetický průměr percentilů finálních pořadí v jednotlivých turnajích. Pokud hráč skončí jednou první a jednou poslední, jeho percentily budou 100 a 0, a jejich průměr 50.",
  chat: "Chat",
  failedToLoadMessages: "Nepodařilo se načíst zprávy",
  failedToSendMessage: "Nepodařilo se odeslat zprávu",
  failedToReactToMessage: "Nepodařilo se přidat reakci",
  react: "Reagovat",
  addReaction: "Přidat reakci",
  removeReaction: "Odebrat reakci",
  reply: "Odpovědět",
  replyingTo: "Odpověď pro",
  edit: "Upravit",
  edited: "upraveno",
  editedAt: "Upraveno v {{time}}",
  pin: "Připnout",
  unpin: "Odepnout",
  pinned: "Připnuté",
  failedToEditMessage: "Nepodařilo se upravit zprávu",
  failedToPinMessage: "Nepodařilo se připnout zprávu",
  someoneIsTyping: "{{name}} píše…",
  twoAreTyping: "{{first}} a {{second}} píší…",
  severalAreTyping: "{{count}} lidí právě píše…",
  failedToDeleteMessage: "Nepodařilo se smazat zprávu",
  loadMore: "Načíst další",
  send: "Odeslat",
  typeMessage: "Napiš zprávu...",
  delete: "Smazat",
  reload: "Obnovit",
  loading: "Načítání...",
  cannotChatInfo: "Pro možnost psaní zpráv je potřeba mít vytvořený účet a prolinkovat ho s herním profilem.",
  deleteMessage: "Smazat zprávu",
  deleteMessageConfirmation: "Opravdu chcete tuto zprávu smazat? Tuto akci nelze vrátit zpět.",
  changePassword: "Změnit heslo",
  resetPassword: "Resetovat heslo",
  resetPasswordConfirmation: "Opravdu chcete resetovat heslo? Tuto akci nelze vrátit zpět.",
  currentPassword: "Aktuální heslo",
  resetPasswordOf: "Resetovat heslo pro {{username}}",
  iUnderstand: "Rozumím",
  wannaChat: "Než začneš psát…",
  chatRules1: "Chat je veřejný - co napíšeš, vidí kdokoliv. Tak tu moc nezlobte. :D",
  unreadChatMessages: "Nové zprávy v chatu",
  unreadChatMention: "Byl jsi zmíněn v chatu",
  unreadNews: "Nový záznam v novinkách",
  averageMatchDuration: "Průměrná doba zápasu",
  emoji: "Emoji",
  gif: "GIF",
  searchGifs: "Hledat GIFy…",
  groupOverview: "Přehled skupin ({{round}}. kolo)",
  hallOfFame: "Síň slávy",
  legends: "Legendy",
  recordMatches: "Rekordní zápasy",
  record_HIGHEST_ELO: "Nejvyšší dosažené Elo",
  record_LONGEST_WIN_STREAK: "Nejdelší série výher",
  record_MOST_TOURNAMENTS_WON: "Nejvíce vyhraných turnajů",
  record_MOST_TOP3_PLACEMENTS: "Nejvíce umístění v Top 3",
  record_MOST_TOURNAMENTS_PLAYED: "Nejvíce odehraných turnajů",
  record_MOST_MATCHES_WON: "Nejvíce vyhraných zápasů",
  record_SHORTEST_MATCH: "Nejkratší zápas",
  record_SHORTEST_MATCH_BO3: "Nejkratší zápas (2 vítězné)",
  record_SHORTEST_MATCH_BO5: "Nejkratší zápas (3 vítězné)",
  record_MOST_BALANCED: "Nejvyrovnanější zápas",
  record_MOST_BALANCED_BO3: "Nejvyrovnanější zápas (2 vítězné)",
  record_MOST_BALANCED_MATCH_BO5: "Nejvyrovnanější zápas (3 vítězné)",
  record_BIGGEST_ELO_SHIFT: "Největší změna Elo ratingu",
  record_BIGGEST_ELO_HAUL: "Největší Elo úlovek",
  record_HIGHEST_ELO_MATCH: "Zápas s nejvyšším součtem Elo",
  record_LONGEST_MATCH: "Nejdelší zápas",
  record_LONGEST_MATCH_BO3: "Nejdelší zápas (2 vítězné)",
  record_LONGEST_MATCH_BO5: "Nejdelší zápas (3 vítězné)",
  record_LONGEST_SET: "Nejdelší set",
  record_BIGGEST_COMEBACK: "Největší obrat v zápase",
  record_BIGGEST_COMEBACK_BO3: "Největší obrat v zápase (2 vítězné)",
  record_BIGGEST_COMEBACK_BO5: "Největší obrat v zápase (3 vítězné)",
  record_MOST_ACHIEVEMENTS: "Nejvíce udělených ocenění",
  record_HIGHEST_TOURNAMENT_RATING: "Nejvyšší turnajový rating",
  record_HIGHEST_MATCH_RATING: "Nejvyšší výkonnostní rating",
  topMatches: "Top zápasy",
  currentRound: "Aktuální kolo",
  otherRounds: "Ostatní kola",
  myMatches__start: "Začátek turnaje - nasazení na {{seeding}}. místě",
  myMatches__swissRound: "Konec {{round}}. kola - průběžné umístění: {{placement}}. místo",
  myMatches__groupRound: "Konec první fáze turnaje - umístění ve skupině: {{placement}}. místo",
  myMatches__playoffRound: "Konec playoff kola {{round}}",
  myMatches__end: "Konec turnaje - finalální umístění: {{placement}}. místo",
  myMatches__end_wellDone: "Konec turnaje - finalální umístění: {{placement}}. místo. Dobrá práce!",
  actions: "Akce",
  matchDetail: "Detail zápasu",
  headToHead: "Vzájemné zápasy",
  noHeadToHeadHistory: "Žádné předchozí zápasy mezi těmito hráči.",
  detail: "Detail",
  winProbability: "Pravděpodobnost výhry",
  currentForm: "Aktuální forma",
  winStreak: "Série výher",
  matchesPlayed: "Odehraných zápasů",
  avgRating: "Prům. rating",
  lastVictory: "Poslední výhra",
  eloGained: "Získané Elo",
  previousMatches: "Předchozí zápasy",
  themeLight: "Světlý režim",
  themeDark: "Tmavý režim",
  themeProjector: "Režim projektoru",
  all: "Vše",
  playoff: "Playoff",
  playoffBracket: "Playoff pavouk",
  winnersBracket: "Hlavní pavouk",
  losersBracket: "Pavouk poražených",
  grandFinal: "Velké finále",
  grandFinalMatch: "Velké finále",
  bracketReset: "Rozhodující zápas",
  thirdPlaceMatch: "Zápas o 3. místo",
  final: "Finále",
  bench: "Lavička",
  moveToBench: "Dát na lavičku",
  returnFromBench: "Vrátit z lavičky",
  queue: "Fronta",
  stopGeneration: "Zastavit",
  resumeGeneration: "Spustit",
  generationStopped: "Generování zastaveno",
  generationRunning: "Generování běží",
  onBench: "Na lavičce",

  accessDenied: "Přístup zamítnut",

  // Awards ceremony tab
  awardsCeremony: "Vyhlášení",
  awardsIntro__title: "Vyhlášení turnaje",
  awardsIntro__hint: "Šipkou doprava začněte vyhlašovat od posledního místa →",
  previousPlayer: "Předchozí hráč",
  nextPlayer: "Další hráč",
  noFinalPlacements: "Žádné konečné umístění k zobrazení",
  noAchievementsThisTournament: "Hráč v tomto turnaji nezískal žádné ocenění.",

  // Awards ceremony - fun facts (priority order, first applicable wins)
  // Firsts (cross-tournament)
  funFact__firstEver: "Tohle byl jeho úplně první turnaj - vítej mezi námi!",
  funFact__firstTop3InLadder: "První umístění na bedně v tomhle žebříčku!",
  funFact__firstWinInLadder: "První vítězný turnaj v tomhle žebříčku - gratulujeme!",
  funFact__firstInLadder: "Premiéra v tomhle žebříčku!",
  // Personal records (cross-tournament)
  funFact__newBestPlacement: "Jeho dosud nejlepší umístění v tomhle žebříčku - dobrá práce!",
  funFact__newEloHigh: "Tímto turnajem dosáhl svého zatím nejvyššího Elo ratingu v tomhle žebříčku!",
  funFact__tiedBestPlacement: "Vyrovnal své dosud nejlepší umístění v tomhle žebříčku!",
  // Comeback / veteran (cross-tournament)
  funFact__longReturn: "Vrátil se po {{months}} měsících pauzy - comeback je tu!",
  funFact__ladderMilestone: "Jeho {{count}}. turnaj v tomhle žebříčku - pomalu se nám tu zabydluje!",
  funFact__careerMilestone: "Jeho {{count}}. turnaj celkem - opravdový pingpongový mazák!",
  // Tournament moments (within-tournament)
  funFact__topMatchFeatured: "Jeden z jeho zápasů se dostal mezi top zápasy turnaje!",
  funFact__beatTheWinner: "Porazil eventuálního vítěze turnaje!",
  funFact__topSeed: "Šel do turnaje jako nejvýše nasazený hráč - favorit dne!",
  funFact__beatTopSeed: "Sundal nejvýše nasazeného hráče turnaje - respekt!",
  funFact__longerWinStreak: "Vyhrál {{count}} zápasů v řadě - pořádná šňůra!",
  funFact__allMatchesDecisive: "Každý jeho zápas šel do rozhodujícího setu - dnes to bylo o nervy!",
  funFact__closestMatch: "Hrál nejtěsnější zápas turnaje - žádný set nekončil rozdílem větším než {{points}} míčků!",
  funFact__highestEloMatch: "Hrál zápas s nejvyšším součtem Elo hráčů - nejvíc nabušený souboj!",
  funFact__mostBalancedMatch: "Hrál nejvyrovnanější zápas turnaje podle Elo - jako vejce vejci!",
  funFact__biggestSetMarginWin: "Vyhrál nejjednoznačnější set turnaje (rozdíl {{margin}} míčků)!",
  funFact__allOpponentsHigherElo: "Všichni jeho soupeři měli vyšší Elo než on - nasazení do hluboké vody!",
  funFact__rematchedOpponent: "Stejného soupeře potkal v turnaji víckrát - rivalita roste!",
  funFact__mostLikedMatch: "Jeho zápas nasbíral nejvíc srdíček z celého turnaje - bavič dne!",
  funFact__firstMatchOfTournament: "Otevíral turnaj svým zápasem - žádný klid na rozcvičení!",
  funFact__lastMatchOfTournament: "Jeho zápas turnaj zakončoval - finálový moment!",
  funFact__topEloGain: "Z turnaje si odnesl nejvíc Elo bodů (+{{elo}}) - nafarmeno!",
  funFact__upset: "Porazil hráče s o {{diff}} vyšším Elem - krásný overperformance!",
  funFact__comebackKing: "{{count}}× otočil zápas po prohraném prvním setu - nervy jak špagáty!",
  funFact__longestMatch: "Hrál nejdelší zápas turnaje - pořádný maratón s {{points}} míčky!",
  funFact__longestSet: "Sehrál nejdelší set turnaje ({{points}} míčků) - to bylo snad naschvál ne?",
  funFact__decisiveSetHero: "{{count}}× šel zápas do rozhodujícího setu a zvládl ho - chladná hlava!",
  funFact__closeSetMaster: "Vyhrál {{count}} setů rozdílem dvou míčků nebo míň - všechno měl pod kontrolou!",
  funFact__longSets: "Sehrál {{count}} dlouhých setů přes 20 míčků - drama na drama!",
  funFact__cleanWins: "Všechny ({{count}}) své výhry zvládl bez rozhodujícího setu - efektivní!",
  // Neutral fallbacks - varied so 25 players don't see the same line
  funFact__generic1: "Odešel domů s {{sets}} vyhranými sety a {{points}} míčky v kapse.",
  funFact__generic2: "Bilance: {{matches}} zápasů, {{sets}} vyhraných setů - den se vydařil.",
  funFact__generic3: "Dnes to lítalo slušně - těch {{points}} míčků už mu nikdo nevezme zpět!",

  // Zákulisí (Backstage)
  zakulisi: "Zákulisí",
  zakulisi__players: "Hráči",
  zakulisi__users: "Účty",
  zakulisi__tournaments: "Turnaje",
  zakulisi__matches: "Zápasy",
  zakulisi__searchPlayer: "Hledat hráče podle jména…",
  zakulisi__searchUser: "Hledat účet podle uživatelského jména…",
  zakulisi__searchTournament: "Hledat turnaj podle názvu…",
  zakulisi__searchPlayerForMatches: "Najdi hráče, jehož zápasy chceš upravit…",
  zakulisi__viewMatches: "Zápasy",
  zakulisi__back: "Zpět",
  zakulisi__edit: "Upravit",
  zakulisi__editing: "Upravuji",
  zakulisi__type: "Typ",
  zakulisi__sets: "Sety",
  zakulisi__hidden: "Skrytý turnaj",
  zakulisi__hiddenHelp: "Skryté turnaje se nezobrazují ve veřejných výpisech.",
  zakulisi__state: "Stav",
  zakulisi__date: "Datum",
  zakulisi__role: "Role",
  zakulisi__playerId: "ID hráče",
  zakulisi__userId: "ID účtu",
  zakulisi__linkUser: "Připojit účet",
  zakulisi__linkUserFor: "Připojení účtu pro",
  zakulisi__link: "Připojit",
  zakulisi__unlink: "Odpojit",
  zakulisi__promoteToAdmin: "Povýšit na ADMIN",
  zakulisi__demoteToUser: "Degradovat na USER",
  zakulisi__superadminProtected: "Chráněno",

  // Audit log
  auditLog: "Audit log",
  administrationActions: "Akce",
  auditLog__allActions: "Všechny akce",
  auditLog__usernameFilter: "Uživatelské jméno",
  auditLog__from: "Od",
  auditLog__to: "Do",
  auditLog__when: "Datum a čas",
  auditLog__user: "Uživatel",
  auditLog__action: "Akce",
  auditLog__entity: "Entita",
  auditLog__details: "Detaily",
  auditLog__empty: "Žádné záznamy",
  auditAction__USER_REGISTERED: "Registrace uživatele",
  auditAction__USER_PASSWORD_CHANGED: "Změna hesla",
  auditAction__USER_PASSWORD_RESET: "Reset hesla",
  auditAction__USER_ROLE_CHANGED: "Změna role",
  auditAction__PLAYER_CREATED: "Vytvoření hráče",
  auditAction__PLAYER_UPDATED: "Úprava hráče",
  auditAction__PLAYER_USER_LINK_CHANGED: "Změna propojení hráč↔účet",
  auditAction__TOURNAMENT_CREATED: "Vytvoření turnaje",
  auditAction__TOURNAMENT_UPDATED: "Úprava turnaje",
  auditAction__TOURNAMENT_PLAYERS_SET: "Nasazení hráčů",
  auditAction__TOURNAMENT_STARTED: "Začátek turnaje",
  auditAction__TOURNAMENT_FINISHED: "Konec turnaje",
  auditAction__TOURNAMENT_DOUBLE_ELIMINATION_TOGGLED: "Double elimination",
  auditAction__TOURNAMENT_BLAST_GENERATION_TOGGLED: "Blast generování",
  auditAction__BLAST_PLAYER_BENCHED: "Blast - hráč na lavičku",
  auditAction__BLAST_PLAYER_RETURNED: "Blast - návrat z lavičky",
  auditAction__ROUND_FINISHED: "Konec kola",
  auditAction__ROUND_CANCELED: "Zrušení kola",
  auditAction__MATCH_RESULT_SET: "Zadání výsledku",
  auditAction__CHAT_MESSAGE_DELETED: "Smazání zprávy",
  auditAction__STICKY_NOTE_DELETED: "Smazání papírku z nástěnky",
  auditAction__ELO_RECALCULATED: "Přepočet Elo",

  // Nástěnka (bulletin board)
  board: "Nástěnka",
  boardLoginRequired: "Nástěnka je jen pro přihlášené. Přihlas se a nalep svůj papírek!",
  boardLinkRequired: "Nástěnka je dostupná jen uživatelům s propojeným hráčským profilem. Požádej admina o propojení účtu.",
  boardNewNote: "Nový papírek",
  boardEmpty: "Nástěnka je zatím prázdná — nalep první papírek!",
  boardPlaceHint: "Klepni na místo, kam chceš papírek nalepit",
  boardRotate: "Otočit papírek",
  boardRotateHint: "Táhni po nástěnce a papírek se otočí kolem připínáčku. Pak potvrď.",
  boardZoomIn: "Přiblížit",
  boardZoomOut: "Oddálit",
  boardZoomFit: "Zobrazit celou nástěnku",
  boardMoveOwnHint: "Tip: nástěnku posouvej tažením a přibližuj kolečkem nebo dvěma prsty. Svoje papírky můžeš přetáhnout jinam a tlačítkem ↻ je otočit.",
  boardDeleteNoteTitle: "Smazat papírek?",
  boardDeleteNoteMessage: "Papírek bude z nástěnky nenávratně sundán.",
  boardCreateFailed: "Papírek se nepodařilo nalepit. Zkus to prosím znovu.",
  boardImageTooLarge: "Kresba je moc velká, zkus ji trochu zjednodušit.",
  boardEditorTitle: "Nový papírek",
  boardTool_pen: "Tužka",
  boardTool_marker: "Fixa",
  boardTool_rainbow: "Duha",
  boardTool_eraser: "Guma",
  boardTool_text: "Text",
  boardTool_emoji: "Samolepky",
  boardPenColor: "Barva",
  boardStrokeWidth: "Tloušťka",
  boardPaperColor: "Papírek",
  boardPinColor: "Připínáček",
  boardFont: "Písmo",
  boardUndo: "Zpět",
  boardRedo: "Znovu",
  boardClear: "Vyčistit",
  boardPin: "Nalepit na nástěnku",
  boardTextPlaceholder: "Napiš text…",
  boardPollToggle: "Hlasovací papírek",
  boardPollHint: "Pod papírkem bude hlasovací lišta — ostatní na ni můžou přidat svůj hlas ✅ nebo ❌. Každý má jeden hlas a kdykoli ho může změnit.",
  boardPollYes: "Hlasovat PRO",
  boardPollNo: "Hlasovat PROTI",
  boardPollRetract: "Vzít hlas zpět",
  boardTextHint: "Klepni na papírek na místo, kam chceš psát. Objeví se políčko — napiš text a potvrď Enterem nebo zelenou fajfkou.",
  boardEmojiHint: "Vyber samolepku a klepni na papírek, kam ji chceš otisknout. Velikost změníš posuvníkem Tloušťka.",
};

export default cs;
